export enum BuiltToSellCategoryEnum {
  BASIC = 'Basic',
  MID_MARKET = 'MidMarket',
  PRIME = 'Prime',
  SUPER_PRIME = 'SuperPrime',
}
